import { RolesEnum } from "@wc/domain/authz";

export const OrgRoles = [RolesEnum.ORG_ADMIN, RolesEnum.ORG_MEMBER];
